import { render, staticRenderFns } from "./AddRtWr.vue?vue&type=template&id=3323a4bd"
import script from "./AddRtWr.vue?vue&type=script&lang=js"
export * from "./AddRtWr.vue?vue&type=script&lang=js"
import style0 from "./AddRtWr.vue?vue&type=style&index=0&id=3323a4bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports